"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
const react_1 = __importDefault(require("react"));
const COLOR_DEFAULT = 'var(--p-color-bg-surface-secondary';
const Highlight = ({ children, color = COLOR_DEFAULT }) => {
    return (react_1.default.createElement("span", { style: {
            backgroundColor: color,
            padding: '2px 3px'
        } }, children));
};
exports.Highlight = Highlight;
